import { inject, Injectable } from "@angular/core";

import {
    HtmlContext,
    HtmlDirective,
    HtmlDirectiveEvaluator,
    HtmlDirectiveEvaluatorSettings,
    HtmlSequence
} from "@main/reporting.v3/widget.html/models";
import {
    HtmlBaseExpressionsArgumentService
} from "@main/reporting.v3/widget.html/services/html-expressions/html-base-expressions-argument.service";


@Injectable()
export class HtmlRangeDirectiveService implements HtmlDirectiveEvaluator {

    private argumentService: HtmlBaseExpressionsArgumentService = inject(HtmlBaseExpressionsArgumentService);

    public readonly directive: string = "range";

    public async evaluate(directive: HtmlDirective, settings: HtmlDirectiveEvaluatorSettings): Promise<any> {
        if (!directive || directive.name !== this.directive || !settings) return null;

        const args: HtmlSequence[] = directive.arguments.slice(0, 2);
        const params: any[] = await this.argumentService.evaluateAll(args, settings);
        const first: number = this.argumentService.toNumber(params[0]);
        const second: number = this.argumentService.toNumber(params[1]);

        if (first == null) return null;

        return this.range(settings.context, first, second);
    }

    private async range(context: HtmlContext, first: number, second: number): Promise<any> {
        try {
            if (!context || first == null) return null;

            const list: number[] = second == null
                ? this.enumerate(0, first)
                : this.enumerate(first, second);

            return !!list ? JSON.stringify(list) : null;

        } catch (error) {
            return null;
        }
    }

    private enumerate(start: number, end: number): number[] {
        // List start cannot be greater or equal to list end (it is exclusive).
        if (start >= end) return null;

        const lenght: number = end - start;

        // Lenght cannot be superior to maximum lenght.
        if (lenght > 100000) return null;

        // List lenght cannot be negative.
        if (lenght < 0) return null;

        return Array.from({ length: lenght }, (_, i) => start + i);
    }
}